import type { ReactNode } from 'react';
import { PrimaryButton } from '@/components';

interface DocumentEmptyStateProps {
  icon: ReactNode;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}

export function DocumentEmptyState({
  icon,
  title,
  description,
  actionLabel,
  onAction,
}: DocumentEmptyStateProps) {
  return (
    <div className="flex min-h-80 flex-col items-center justify-center gap-4 px-6 py-10 text-center text-onsurface grow">
      <div className="flex size-16 items-center justify-center rounded-full bg-primary/10 text-primary">
        {icon}
      </div>
      <div className="space-y-2">
        <h2 className="text-lg font-semibold">{title}</h2>
        <p className="max-w-md text-sm text-onsurface/70">{description}</p>
      </div>
      {actionLabel && onAction ? (
        <PrimaryButton size="sm" onClick={onAction}>
          {actionLabel}
        </PrimaryButton>
      ) : null}
    </div>
  );
}
